import { useState } from 'react'

import { useUploadPickupOrderBarcode } from '@/api/pickup-orders/queries/usePickupOrders'
import { PickupOrder } from '@/api/pickup-orders/types/PickupOrder'
import { AppDialog } from '@/components/AppDialog'
import { Button } from '@/components/ui/button'
import { useToast } from '@/hooks/useToast'

import { UploadArea } from '../../ReceiptUpload/components/UploadArea'

interface Props {
  order: PickupOrder
  isOpen: boolean
  onOpenChange: (open: boolean) => void
}
export const UploadBarcodeDialog = ({ order, isOpen, onOpenChange }: Props) => {
  const [uploadAreaKey, setUploadAreaKey] = useState(0)
  const [barcodeFile, setBarcodeFile] = useState<File | null>(null)
  const uploadMutation = useUploadPickupOrderBarcode()
  const { showSuccessToast, showErrorToast } = useToast()

  const handleClose = (open: boolean) => {
    if (!open) {
      setUploadAreaKey(k => k + 1)
    }
    onOpenChange(open)
  }

  const onSubmit = async () => {
    if (!barcodeFile) {
      showErrorToast('יש להעלות את הברקוד')
      return
    }
    try {
      await uploadMutation.mutateAsync({ id: order.id, barcodeFile: barcodeFile })
      handleClose(false)
      showSuccessToast('הברקוד נקלט, איזה כיף!', 'אנחנו ממשיכים לאיסוף מפריימרק ומעדכנים אתכם כשההזמנה מגיעה למחסנים שלנו לתשלום.')
    } catch {
      showErrorToast('שגיאה בהעלאת הברקוד. נסה שוב.')
    }
  }

  return (
    <AppDialog
      isOpen={isOpen}
      onOpenChange={handleClose}
      title='הברקוד לאיסוף'
      className='sm:max-w-2xl'
      footerActions={
        <Button loading={uploadMutation.isPending} disabled={uploadMutation.isPending} onClick={onSubmit}>
          העלאת ברקוד
        </Button>
      }
    >
      <div className='flex flex-col gap-4'>
        <p className='text-text-primary'>עם הברקוד הזה השליח שלנו נכנס לפריימרק, סורק את ההזמנה שלכם ואוסף אותה לשיפטנבול :)</p>
        <p className='text-sm'>את הברקוד מקבלים מפריימרק במייל או ב־SMS אחרי ההזמנה.</p>
        <p className='text-text-secondary text-sm font-medium'>ככה נראה הברקוד:</p>
        <div className='border-border-default bg-muted/30 flex h-24 items-center justify-center rounded-lg border-2 border-dashed'>
          <span className='text-text-muted text-xs'>תמונה או קובץ PDF של הברקוד</span>
        </div>
        <div className='flex flex-col gap-4'>
          <UploadArea maxFileCount={1} key={uploadAreaKey} onChangeFile={(file: File | null) => setBarcodeFile(file)} />
        </div>
      </div>
    </AppDialog>
  )
}
